import { render, staticRenderFns } from "./BeyondEconomicalRepair.vue?vue&type=template&id=53479094&"
import script from "./BeyondEconomicalRepair.vue?vue&type=script&lang=js&"
export * from "./BeyondEconomicalRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports